export default "__VITE_ASSET__Byd4mvAA__"